import type { DriveStep } from 'driver.js'

export const apiKeysTour: Array<DriveStep> = [
  {
    element: '#create-api-key-btn',
    popover: {
      title: 'Create API Key',
      description:
        'Click here to generate a new API key. Give it a descriptive name so you can identify it later (e.g., "Production App" or "Testing").',
      side: 'bottom',
    },
  },
  {
    element: '#api-key-list',
    popover: {
      title: 'Manage Your Keys',
      description:
        'View all your API keys, their creation dates, last used times, and usage statistics. You can create unlimited keys for different projects.',
      side: 'top',
    },
  },
  {
    element: '#copy-snippet-example',
    popover: {
      title: 'Integration Code Snippets',
      description:
        'Copy ready-to-use code for OpenAI SDK, Anthropic SDK, cURL, or any HTTP client. Just replace YOUR_API_KEY with your actual key.',
      side: 'left',
    },
  },
  {
    element: '#key-permissions',
    popover: {
      title: 'Key Permissions',
      description:
        'Control what each key can access: specific models, rate limits, or spending caps. Perfect for team collaboration.',
      side: 'right',
    },
  },
  {
    element: '#revoke-key-action',
    popover: {
      title: 'Security Best Practices',
      description:
        'Revoke compromised keys immediately. Rotate keys every 90 days. Never commit keys to version control.',
      side: 'top',
    },
  },
]
